import {z} from "zod";

const schema = z.object({
	fileId: z.string(),
	uploadUrl: z.string(),
	contentType: z.string()
});

const model = schema.transform((values) => ({
	...values
}));

export const GeneratePresignedUrlResModel = {schema, model};
export type IGeneratePresignedUrlResModel = z.infer<typeof GeneratePresignedUrlResModel.model>;
export const DEFAULT_GENERATE_PRESIGNED_URL_RES: IGeneratePresignedUrlResModel = {
	fileId: "",
	contentType: "",
	uploadUrl: ""
};
